<!--客户和客户号联动-->
<template>
  <div class="amap-page-container">
    <el-amap-search-box
      class="search-box"
      :search-option="searchOption"
      :on-search-result="onSearchResult"
      :default="address"
      id="tipinput"
    />
    <el-amap
      ref="map"
      vid="amap"
      :center="mapCenter"
      :zoom="zoom"
      class="amap-demo"
      :events="events"
      :plugin="plugin"
    >
      <el-amap-marker
        v-for="(marker,index) in markers"
        :key="index"
        :position="marker"
        :events="markerEvents"
      />
    </el-amap>
    <div class="toolbar">
      <span v-if="loaded">
        当前位置: lng = {{ lng }} lat = {{ lat }}
      </span>
      <span v-else>正在定位</span>
    </div>
  </div>
</template>
<script>
// 参考vue-amap文档 https://elemefe.github.io/vue-amap/#/zh-cn/introduction/install
import Vue from 'vue'
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '59d19d47875c760a0bc383a9292f1c46',
  plugin: ['Geocoder', 'ToolBar', 'Geolocation'], // 需要用到的插件要在这里初始化
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
})

export default {
  name: 'Map',
  components: {
  },
  props: {
  },
  data () {
    let self = this
    return {
      address: '',
      loaded: false,
      zoom: 12,
      markers: [],
      searchOption: {
        city: '',
        citylimit: false,
      },
      mapCenter: [114.0297284, 22.610080000000004],
      events: {
        click: (e) => {
          let { lng, lat } = e.lnglat
          this.getAdressInfo(lng, lat)
        },
      },
      plugin: [
        // 工具条插件
        {
          pName: 'ToolBar',
          position: 'LB',
        },
        // 定位
        {
          pName: 'Geolocation',
          events: {
            init (o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  self.lng = result.position.lng
                  self.lat = result.position.lat
                  self.mapCenter = [self.lng, self.lat]
                  self.loaded = true
                  self.$nextTick()
                }
              })
            },
          },
        },
      ],
      // 气泡点击事件
      markerEvents: {
        click: (e) => {
          const { lng, lat } = e.lnglat
          this.getAdressInfo(lng, lat)
        },
      },

    }
  },
  mounted () {
  },
  methods: {
    // 获取地址信息
    getAdressInfo (lng, lat) {
      this.lng = lng
      this.lat = lat
      // 这里通过高德 SDK 完成。
      let geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all',
      })
      geocoder.getAddress([lng, lat], (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.regeocode) {
            this.address = result.regeocode.formattedAddress
            // 选中当前点击的位置
            this.markers = [[this.lng, this.lat]]
            this.$emit('returnMapInfo', {
              lng: this.lng,
              lat: this.lat,
              address: this.address,
              addressDetail: result.regeocode.addressComponent,
            })
          }
        }
      })
    },
    // 搜索
    onSearchResult (pois) {
      let latSum = 0
      let lngSum = 0
      if (pois.length > 0) {
        pois.forEach(poi => {
          let { lng, lat } = poi
          lngSum += lng
          latSum += lat
          this.markers.push([poi.lng, poi.lat])
        })
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length,
        }
        this.mapCenter = [center.lng, center.lat]
      }
    },

  },
}
</script>

<style lang="scss" scoped>
  .amap-demo {
    height: 400px;
  }

  .search-box {
    position: absolute;
    top: 25px;
    left: 20px;
  }

  .amap-page-container {
    position: relative;
  }
</style>
